import { gql } from 'graphql-tag'

export const fetchLinkTags = gql`
  query FetchLinkTags {
    linkTags {
      id
      name
    }
  }
`
export const createLinkTag = gql`
  mutation CreateLinkTag($name: String!) {
    createLinkTag(name: $name) {
      id
      name
    }
  }
`

export const deleteLinkTag = gql`
  mutation DeleteLinkTag($id: ID!) {
    deleteLinkTag(id: $id)
  }
`
